<template>
  <div class="refresh-message-all">
    <div class="refresh-message-text">{{ alertMessage }}</div>
    <div class="refresh-button-list">
      <el-dropdown>
        <el-button size="mini">
          稍后提醒
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="remindLater(5)">5分钟后提醒</el-dropdown-item>
          <el-dropdown-item @click.native="remindLater(15)">15分钟后提醒</el-dropdown-item>
          <el-dropdown-item @click.native="remindLater(30)">30分钟后提醒</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button class="refresh-button" type="primary" size="mini" @click="refreshWindow">立即刷新</el-button>
    </div>
  </div>
</template>

<script>
import { refreshWindowAndClearMemory } from '@/util/tools'

export default {
  name: 'refreshMessage',
  props: {
    alertMessage: {
      type: String,
      default: ''
    }
  },
  methods: {
    async refreshWindow() {
      try {
        await this.$confirm('未保存内容在刷新页面后会丢失，请确保所编辑内容均已保存', '提示', {
          confirmButtonText: '继续刷新',
          cancelButtonText: '取消刷新',
          type: 'warning'
        })
        window.NEW_CALL_CENTER_REMIND_MARK_TIME = undefined
        window.NEW_CALL_CENTER_REMIND_LATER_TIME = undefined
        window.localStorage?.setItem?.('wb-refresh-mode', 'alertMessage-refresh-window')
        refreshWindowAndClearMemory()
      } catch (e) {
        console.log(e)
      }
    },
    remindLater(time) {
      this.$emit('remindClose', time)
    }
  }
}
</script>

<style lang="stylus">
.warning-icon-refresh {
  color: #1F5DE9 !important;
}
</style>
<style lang="stylus" scoped>
.refresh-message-all {
  .refresh-button-list {
    margin-top: 20px;
    text-align: right;
    .refresh-button {
      margin-left: 5px;
    }
  }
}
</style>
